import {
  type UseUploadImageForItemSetQuestionCreationInput,
  useUploadImageForQuestion,
} from '../use-upload-image-for-question-creation';

export function useUploadImageForItemSetQuestionCreation(
  params: UseUploadImageForItemSetQuestionCreationInput,
) {
  const { questionGroupId, taskId, options } = params;

  return useUploadImageForQuestion({ questionGroupId, taskId, options });
}
